import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { PersonalizationResponse, Attribute } from './types.tsx';

const PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const SITE_PERSONALIZATION_ENDPOINT = `${PERSONALIZATION_ENDPOINT}/site/`;
const USER_PERSONALIZATION_ENDPOINT = `${PERSONALIZATION_ENDPOINT}/user/`;

const SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT =
	'marketing-signup_track_deferred-sitename_signup_server_enrollment';
const JSW_TRACK_DEFER_SITENAME_TRAIT =
	'jira_track_instance_created_server_defer_site_rename_cohort';

const fetchPersonalization =
	(endpoint: string, subject?: string) =>
	async (
		id: string | number,
		meta?: Record<string, string>,
	): Promise<PersonalizationResponse | undefined> => {
		try {
			const url = endpoint + id;
			return await performGetRequest(url);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				meta: {
					id: 'onboarding',
					teamName: 'jlove-makkuro',
					...meta,
				},
				attributes: { subject },
				error,
			});
			return undefined;
		}
	};

const getTraits =
	(fetch: ReturnType<typeof fetchPersonalization>, traitName: string) =>
	async (id: string | number, meta?: Record<string, string>): Promise<Attribute | undefined> => {
		const personalization = await fetch(id, meta);
		return personalization?.attributes?.find((att) => att.name === traitName);
	};

export const getSignupTrackDeferSitenameUserTrait = getTraits(
	fetchPersonalization(USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'),
	SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT,
);
export const getJswTrackDeferSitenameSiteTrait = getTraits(
	fetchPersonalization(SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'),
	JSW_TRACK_DEFER_SITENAME_TRAIT,
);
